import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1287603379450199';
let initialized = false;
function loadPixelScript() {
  if (typeof window === 'undefined') return;
  if ((window as any).fbq) return;
  const f: any = function (...args: any[]) {
    f.callMethod ? f.callMethod.apply(f, args) : f.queue.push(args);
  };
  f.push = f;
  f.loaded = true;
  f.version = '2.0';
  f.queue = [] as any[];
  (window as any).fbq = f;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
}
export function initPixel() {
  if (initialized) return;
  loadPixelScript();
  const fbq = (window as any).fbq;
  if (fbq) {
    fbq('init', PIXEL_ID);
    initialized = true;
  }
}
export function trackEvent(event: string, data?: Record<string, unknown>) {
  const fbq = (window as any).fbq;
  if (fbq) {
    fbq('track', event, data);
  }
}
export function MetaPixel() {
  useEffect(() => {
    initPixel();
    trackEvent('PageView');
  }, []);
  return null;
}